module.exports = __webpack_public_path__ + "static/media/creditcard.6552026b.png";